import * as types from './actionTypes'
import CategoriesApi from '../api/CategoriesApi'
import ContentApi from '../api/ContentApi'

export function receiveCategories (categ) {
  return {
    type: types.GET_CATEGORIES,
    categ
  }
}

export function saveContentID (data) {
  return {
    type: types.GET_CONTENT_ID,
    data
  }
}

export function passArticleID (id) {
  return {
    type: types.PASS_ARTICLE_ID,
    id
  }
}

export function fetchCategories () {
  return function (dispatch) {
    return CategoriesApi.getCateg()
      .then(response => {
        dispatch(receiveCategories(response))
      })
      .catch(error => {
        throw (error)
      })
  }
}

export function fetchContentID (id) {
  return function (dispatch) {
    return ContentApi.apiContentID(id)
      .then(response => {
        dispatch(saveContentID(response))
      })
      .catch(error => {
        throw (error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/dataActions.js